import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import ScenarioSelectionRedefinedWrapperTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate';
import ScenarioSelectionRedefinedTheYearAheadContent
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTheYearAheadOutflowStepTemplate/Content';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBodyText } from '@facet-wealth/design';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride(['plannerInsightsBody'], {
    _component: () => FDBodyText,
    _customProps: { color: 'textSecondary' },
  }, overrideReadOnly);

const ScenarioSelectionRedefinedTheYearAheadStepTemplate = ({
  resource,
}) => {
  return (
    <ScenarioSelectionRedefinedWrapperTemplate
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={ScenarioSelectionRedefinedTheYearAheadContent}
    />
  );
};

ScenarioSelectionRedefinedTheYearAheadStepTemplate.defaultProps = {
};

ScenarioSelectionRedefinedTheYearAheadStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default ScenarioSelectionRedefinedTheYearAheadStepTemplate;
